"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterSpend = void 0;
var get_1 = __importDefault(require("lodash/fp/get"));
var filter_1 = require("utils/filter");
var useFilterSpend = function (serviceStatsList) { return (0, filter_1.useFilterItems)(serviceStatsList, [(0, get_1.default)('service.name'), (0, get_1.default)('service.niceName')], [filter_1.toolGroupCheck, filter_1.teamsCheck, filter_1.totalSpendGroupCheck], [function (item, search) { return Math.round(item.calculatedAnnualSpend || 0).toString().includes(search.replace(/,/g, '')); }]); };
exports.useFilterSpend = useFilterSpend;
